import React, { useState } from 'react';
import { Trans } from '@lingui/macro';

const PrivacyNotice = () => {
  return (
    <section className='PrivacyNotice-section'>
      <div className='container'>
        <h1><Trans>Politique de confidentialité</Trans></h1>

        <p><strong><Trans>Version en vigueur au 16/06/2025</Trans></strong></p>

        <p><Trans>REPAT attache une grande importance à la protection des données à caractère personnel et de la vie privée de ses utilisateurs. A cette fin, REPAT agit en tant que responsable du traitement et s'engage à procéder aux traitements de ces données à caractère personnel conformément aux lois et réglementations applicables.</Trans></p>

        <p><Trans>La présente politique de confidentialité (la « Politique de Confidentialité ») expose la manière dont REPAT collecte et traite des données vous concernant dans le cadre de votre utilisation de notre application.</Trans></p>

        <h2><Trans>Introduction</Trans></h2>
        <p><Trans>La présente politique de confidentialité détaille les conditions dans lesquelles la SAS Repat Founders, Société par Actions Simplifiée (SAS) au capital social de 1 000 euros, immatriculée au Registre du Commerce et des Sociétés (RCS) de Paris sous le numéro 934 051 723, dont le siège social est situé 66 Avenue des Champs Elysées, 75008 Paris, France, représentée par son président Monsieur Diabi Karamoko, collecte, traite, conserve et protège les données personnelles des utilisateurs de son application accessible via les principales plateformes de téléchargement.</Trans></p>

        <p><Trans>L'application permet à ses adhérents de créer un profil, d'interagir avec la communauté, d'accéder à des actualités, à la liste des prochains événements, de poser des questions et, à terme, de bénéficier de recommandations personnalisées.</Trans></p>

        <h2><Trans>Responsable du traitement</Trans></h2>
        <p><Trans>Le responsable du traitement des données à caractère personnel collectées via l'application est Monsieur Diabi Karamoko. Le courriel de contact pour toute question relative à la confidentialité : tech@repat.africa.</Trans></p>

        <h2><Trans>Données collectées</Trans></h2>
        <p><Trans>Les données à caractère personnel collectées et traitées par l'application sont les suivantes :</Trans></p>
        <ul>
          <li><Trans>Nom</Trans></li>
          <li><Trans>Prénom</Trans></li>
          <li><Trans>Adresse email</Trans></li>
          <li><Trans>Date de naissance (utilisée à des fins statistiques uniquement, non affichée publiquement)</Trans></li>
          <li><Trans>Pays d'origine</Trans></li>
          <li><Trans>Pays de résidence</Trans></li>
          <li><Trans>Numéro de téléphone</Trans></li>
          <li><Trans>Description du profil</Trans></li>
        </ul>
        <p><Trans>Seules les données strictement nécessaires à la création et à la gestion du profil, à la mise en relation entre membres, à l'accès aux fonctionnalités communautaires et à l'amélioration du service sont collectées, conformément au principe de minimisation et de proportionnalité.</Trans></p>

        <h2><Trans>Finalités du traitement</Trans></h2>
        <p><Trans>Les traitements de données ont pour finalité :</Trans></p>
        <ul>
          <li><Trans>L'instruction des candidatures à la communauté</Trans></li>
          <li><Trans>La gestion et l'affichage des profils utilisateurs</Trans></li>
          <li><Trans>La mise en relation des membres et l'ajout mutuel</Trans></li>
          <li><Trans>L'accès aux actualités, aux événements et aux questions de la communauté</Trans></li>
          <li><Trans>La fourniture à terme de recommandations personnalisées par intelligence artificielle</Trans></li>
          <li><Trans>La réalisation de statistiques internes anonymisées (ex : date de naissance non affichée)</Trans></li>
          <li><Trans>La gestion de la sécurité et du support technique</Trans></li>
        </ul>
        <p><Trans>Conformément au RGPD, chaque finalité est déterminée, explicite et légitime.</Trans></p>

        <h2><Trans>Base légale du traitement</Trans></h2>
        <p><Trans>Les traitements réalisés reposent sur :</Trans></p>
        <ul>
          <li><Trans>L'exécution du contrat d'adhésion ou de l'inscription à l'application ;</Trans></li>
          <li><Trans>L'intérêt légitime de la société à développer et animer la communauté ;</Trans></li>
          <li><Trans>Le respect d'obligations légales le cas échéant.</Trans></li>
        </ul>

        <h2><Trans>Destinataires des données</Trans></h2>
        <p><Trans>Les données sont accessibles :</Trans></p>
        <ul>
          <li><Trans>Aux membres autorisés de la SAS Repat Founders (gestion et support) ;</Trans></li>
          <li><Trans>Aux autres adhérents pour les données expressément rendues visibles sur le profil (hors date de naissance) ;</Trans></li>
        </ul>

        <h2><Trans>Hébergement et transferts de données</Trans></h2>
        <p><Trans>Les données sont hébergées sur les serveurs de Linode Akamai, en France. En cas de transfert hors UE, l'éditeur s'engage à mettre en œuvre les garanties appropriées conformément à l'article 46 et suivants du RGPD.</Trans></p>

        <h2><Trans>Durée de conservation</Trans></h2>
        <p><Trans>Les données personnelles collectées et listées sont conservées par REPAT FOUNDERS pour des durées n'excédant pas l'accomplissement des finalités décrites à l'article 4, sauf obligation légale contraire ou sur demande expresse d'effacement. Au terme de ce délai, les données sont supprimées ou anonymisées de manière irréversible.</Trans></p>

        <h2><Trans>Droits des utilisateurs</Trans></h2>
        <p><Trans>Chaque utilisateur dispose, dans les conditions prévues par la réglementation, des droits suivants :</Trans></p>
        <ul>
          <li><Trans>Droit d'accès à ses données</Trans></li>
          <li><Trans>Droit de rectification et de mise à jour</Trans></li>
          <li><Trans>Droit d'effacement (« droit à l'oubli »)</Trans></li>
          <li><Trans>Droit de limitation du traitement</Trans></li>
          <li><Trans>Droit d'opposition</Trans></li>
          <li><Trans>Droit à la portabilité de ses données</Trans></li>
          <li><Trans>Droit de définir des directives post-mortem</Trans></li>
        </ul>
        <p><Trans>Pour exercer ces droits, il suffit d'adresser une demande à tech@repat.africa, en justifiant de son identité.</Trans></p>

        <h2><Trans>Sécurité des données</Trans></h2>
        <p><Trans>La SAS Repat Founders met en œuvre toutes les mesures techniques et organisationnelles appropriées pour garantir la sécurité, l'intégrité et la confidentialité des données personnelles contre tout accès, divulgation, altération ou destruction non autorisés. Cela comprend notamment :</Trans></p>
        <ul>
          <li><Trans>La pseudonymisation et le chiffrement des données</Trans></li>
          <li><Trans>Le contrôle d'accès strict aux données</Trans></li>
          <li><Trans>Des procédures régulières de tests et d'évaluation de la sécurité</Trans></li>
          <li><Trans>Une notification aux autorités et aux personnes concernées en cas de violation avérée de données à caractère personnel</Trans></li>
        </ul>

        <h2><Trans>Transparence et information</Trans></h2>
        <p><Trans>Toutes les informations relatives au traitement des données sont accessibles, compréhensibles et formulées en termes clairs et simples. Les utilisateurs sont informés de toute modification substantielle de la présente politique de confidentialité.</Trans></p>

        <h2><Trans>Support et réclamation</Trans></h2>
        <p><Trans>Pour toute demande, question ou réclamation concernant la protection de vos données, vous pouvez nous contacter à l'adresse suivante : tech@repat.africa.</Trans></p>
        <p><Trans>Vous disposez également du droit d'introduire une réclamation auprès de la CNIL (Commission nationale de l'informatique et des libertés) si vous estimez que vos droits ne sont pas respectés.</Trans></p>

        <h2><Trans>Mise à jour de la politique</Trans></h2>
        <p><Trans>Cette politique est susceptible d'être modifiée pour tenir compte de l'évolution de la réglementation applicable ou du service proposé. Toute modification sera notifiée par tout moyen approprié aux utilisateurs.</Trans></p>
      </div>
    </section>
  )
}

export default PrivacyNotice;
